import { Button, Icon, Tooltip } from 'antd';
import cn from 'classnames';
import React from 'react';

import Calendar from '../../../../../../../Calendar/Calendar';
import { views } from '../../../../../../../Calendar/constants/views';
import SearchInput from '../../../../../../../HousingStock/components/common/SearchInput/SearchInput';
import styles from '../../ScheduleCalendar.module.scss';
import {
  compactResourceColumnWidth,
  compactResourceDateColumnWidth,
  compactResourceHeaderHeight,
  compactResourceRowMinHeight,
  defaultResourceColumnWidth,
  defaultResourceDateColumnMinWidth,
} from '../../constants';
import { transformSchedulesToCalendarData } from '../../utils/transformSchedulesToCalendarData';

export const ScheduleCalendarView = ({
  enableIntervalAssignment,
  filteredPerformers,
  handleCompactCalendarToggle,
  handleSearchChange,
  initialSheet,
  isCompactCalendar,
  renderEmptyScheduleTask,
  renderIntervalAssignment,
  renderPerformer,
  renderScheduleAddresses,
  renderScheduleTask,
  schedulesToShow,
  searchValue,
  selectedScheduleName,
  selectedSchedulePeriodText,
}) => (
  <div className={styles.root}>
    <div className={styles.header}>
      <div className={styles.titleRow}>
        <span className={styles.title}>
          <span className={styles.titleName}>{selectedScheduleName}</span>
          {selectedSchedulePeriodText && (
            <span className={styles.titlePeriod}>
              {selectedSchedulePeriodText}
            </span>
          )}
        </span>
        <Tooltip
          title={
            isCompactCalendar
              ? 'Показать подробный календарь'
              : 'Показать компактный календарь'
          }
        >
          <Button
            className={cn(styles.button, styles.compactToggle, {
              [styles.compactToggle_active]: isCompactCalendar,
            })}
            aria-label={
              isCompactCalendar
                ? 'Показать подробный календарь'
                : 'Показать компактный календарь'
            }
            aria-pressed={isCompactCalendar}
            onClick={handleCompactCalendarToggle}
          >
            <Icon type={isCompactCalendar ? 'fullscreen' : 'fullscreen-exit'} />
          </Button>
        </Tooltip>
      </div>
      <div className={styles.search}>
        <SearchInput
          id="search"
          className={styles.searchInput}
          placeholder="Поиск"
          value={searchValue}
          onChange={handleSearchChange}
        />
      </div>
    </div>
    <div className={styles.body}>
      <div className={styles.calendarContainer}>
        <Calendar
          external
          initialView={views.month}
          initialSheet={initialSheet}
          showCurrentDate={false}
          schedules={schedulesToShow}
          getCalendarData={transformSchedulesToCalendarData}
          resourceRows={filteredPerformers}
          resourceColumnTitle={
            <span className={styles.performersColumnTitle}>Исполнители</span>
          }
          resourceColumnWidth={
            isCompactCalendar
              ? compactResourceColumnWidth
              : defaultResourceColumnWidth
          }
          resourceDateColumnMinWidth={
            isCompactCalendar
              ? compactResourceDateColumnWidth
              : defaultResourceDateColumnMinWidth
          }
          resourceHeaderHeight={
            isCompactCalendar ? compactResourceHeaderHeight : undefined
          }
          resourceRowMinHeight={
            isCompactCalendar ? compactResourceRowMinHeight : undefined
          }
          resourceCompact={isCompactCalendar}
          renderResourceRowHeader={renderPerformer}
          renderResourceFooter={
            enableIntervalAssignment
              ? renderIntervalAssignment
              : renderScheduleAddresses
          }
          renderResourceTask={renderScheduleTask}
          renderResourceEmptyTask={renderEmptyScheduleTask}
          resourceEmptyText="Нет исполнителей"
          headerProps={{
            rootClassName: styles.calendarHeaderHidden,
            choosePeriodRootClassName: styles.choosePeriod,
            showModeControls: false,
            showOwnerToggle: false,
          }}
        />
      </div>
    </div>
  </div>
);
